import { render, staticRenderFns } from "./oll.vue?vue&type=template&id=323e5353&scoped=true&"
import script from "./oll.vue?vue&type=script&lang=js&"
export * from "./oll.vue?vue&type=script&lang=js&"
import style0 from "./oll.vue?vue&type=style&index=0&id=323e5353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e5353",
  null
  
)

export default component.exports